export const ResearchAction = {
  BUY: 'BUY',
  HOLD: 'HOLD',
  SELL: 'SELL',
} as const;
